import React from 'react';
import { Col } from 'react-bootstrap';

import Separator from '~/components/Separator';
import ToggleDefault from '~/components/ToggleDefault';

import { useRegraLoja } from '~/pages/RegraDeLoja/RegraLojaContext';

import {
  InputNumber,
  InputPercent,
  InputSelect,
} from '~/components/NovosInputs';
import { formatCurrencyBR } from '~/utils/functions';
import {
  tipoPisCofinsEntrada,
  tipoPisCofinsSaida,
  tipoRegimePisCofins,
} from '../../types';

const PisCofins: React.FC = () => {
  const {
    formRegraLoja,
    changeFormRegraLoja,
    formTela: {
      setValue,
      control,
      register,
      formState: { errors },
    },
  } = useRegraLoja();

  return (
    <>
      <div className="row mt-3">
        <div className="col-sm-12 col-md-3">
          <InputSelect
            label="Regime de Tributação (EFD) *"
            placeholder="Selecione o tipo de Tributo"
            name="tipo_regime_pis_cofins"
            options={tipoRegimePisCofins}
            control={control}
            register={register}
            isError={!!errors.tipo_regime_pis_cofins}
            changeSelected={(selected: any) => {
              setValue('tipo_regime_pis_cofins', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                tipo_regime_pis_cofins: {
                  ...formRegraLoja.tipo_regime_pis_cofins,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-3">
          <ToggleDefault
            labelText="Considerar o ICMS-ST na BC Crédito?"
            setChecked={formRegraLoja.flg_st_bc_pis_cof.value}
            onSwitch={() => {
              setValue(
                'flg_st_bc_pis_cof',
                !formRegraLoja.flg_st_bc_pis_cof.value,
              );
              changeFormRegraLoja({
                ...formRegraLoja,
                flg_st_bc_pis_cof: {
                  ...formRegraLoja.flg_st_bc_pis_cof,
                  value: !formRegraLoja.flg_st_bc_pis_cof.value,
                },
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-3">
          <ToggleDefault
            labelText="Considerar o IPI na BC Crédito?"
            setChecked={formRegraLoja.flg_ipi_bc_pis_cof.value}
            onSwitch={() => {
              setValue(
                'flg_ipi_bc_pis_cof',
                !formRegraLoja.flg_ipi_bc_pis_cof.value,
              );
              changeFormRegraLoja({
                ...formRegraLoja,
                flg_ipi_bc_pis_cof: {
                  ...formRegraLoja.flg_ipi_bc_pis_cof,
                  value: !formRegraLoja.flg_ipi_bc_pis_cof.value,
                },
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-3">
          <ToggleDefault
            labelText="Excluir ICMS do BC/COFINS nas Entradas de NF's?"
            setChecked={formRegraLoja.flg_exc_icms_bc_pis_ent.value}
            onSwitch={() => {
              setValue(
                'flg_exc_icms_bc_pis_ent',
                !formRegraLoja.flg_exc_icms_bc_pis_ent.value,
              );
              changeFormRegraLoja({
                ...formRegraLoja,
                flg_exc_icms_bc_pis_ent: {
                  ...formRegraLoja.flg_exc_icms_bc_pis_ent,
                  value: !formRegraLoja.flg_exc_icms_bc_pis_ent.value,
                },
              });
            }}
          />
        </div>
        <Col sm="12">
          <Separator labelText="Incidentes" />
        </Col>
        <Col md="2">
          <div className="">
            <InputPercent
              label="% PIS"
              min={0}
              max={100}
              placeholder=""
              name="val_pis"
              register={register}
              control={control}
              isError={!!errors.val_pis}
              onInput={(ev: any) => {
                const { value } = ev.target;

                setValue('val_pis', value);
                changeFormRegraLoja({
                  ...formRegraLoja,
                  val_pis: {
                    ...formRegraLoja.val_pis,
                    value: Number(value),
                  },
                });
              }}
            />
          </div>
        </Col>

        <div className="col-sm-6 col-md-2">
          <InputPercent
            label="% COFINS"
            min={0}
            max={100}
            placeholder=""
            name="val_cofins"
            register={register}
            control={control}
            isError={!!errors.val_cofins}
            onInput={(ev: any) => {
              const { value } = ev.target;

              setValue('val_cofins', value);
              changeFormRegraLoja({
                ...formRegraLoja,
                val_cofins: {
                  ...formRegraLoja.val_cofins,
                  value: Number(value),
                },
              });
            }}
          />
        </div>

        <div className="col-sm-6 col-md-2">
          <InputNumber
            label="Código DARF PIS"
            placeholder=""
            name="cod_darf_pis"
            register={register}
            control={control}
            isError={!!errors.cod_darf_pis}
            min={0}
            max={9999}
            maxLength={9}
            onInput={(ev: any) => {
              const { value } = ev.target;

              if (String(value).length <= 9) {
                setValue(
                  'val_cofins',
                  Number(value.toString().replace('-', '')),
                );
                changeFormRegraLoja({
                  ...formRegraLoja,
                  cod_darf_pis: {
                    ...formRegraLoja.cod_darf_pis,
                    value: Number(value.toString().replace('-', '')),
                  },
                });
              }
            }}
          />
        </div>

        <div className="col-sm-6 col-md-2">
          <InputNumber
            label="Código DARF COFINS"
            placeholder=""
            min={0}
            maxLength={9}
            name="cod_darf_cofins"
            register={register}
            control={control}
            isError={!!errors.cod_darf_cofins}
            max={9999}
            onInput={(ev: any) => {
              const { value } = ev.target;

              if (String(value).length <= 9) {
                setValue(
                  'cod_darf_cofins',
                  Number(value.toString().replace('-', '')),
                );
                changeFormRegraLoja({
                  ...formRegraLoja,
                  cod_darf_cofins: {
                    ...formRegraLoja.cod_darf_cofins,
                    value: Number(value.toString().replace('-', '')),
                  },
                });
              }
            }}
          />
        </div>

        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsEntrada}
            label="CST Entrada"
            name="cst_pis_cof_entrada"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_entrada}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_entrada', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_entrada: {
                  ...formRegraLoja.cst_pis_cof_entrada,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>

        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsSaida}
            label="CST Saída"
            name="cst_pis_cof_saida"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_saida}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_saida', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_saida: {
                  ...formRegraLoja.cst_pis_cof_saida,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>
      </div>

      <div className="row">
        <Col sm="12">
          <Separator labelText="Não Incidentes" />
        </Col>
        <Col md="6">
          <div className="">
            <InputSelect
              options={tipoPisCofinsEntrada}
              label="CST Entrada Aliquota Zero"
              name="cst_pis_cof_ent_aliq_zero"
              control={control}
              register={register}
              isError={!!errors.cst_pis_cof_ent_aliq_zero}
              changeSelected={(selected: any) => {
                setValue('cst_pis_cof_ent_aliq_zero', selected);
                changeFormRegraLoja({
                  ...formRegraLoja,
                  cst_pis_cof_ent_aliq_zero: {
                    ...formRegraLoja.cst_pis_cof_ent_aliq_zero,
                    value: selected,
                    isInvalid: selected.value === undefined,
                  },
                });
              }}
            />
          </div>
        </Col>
        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsSaida}
            label="CST Saída Aliquota Zero"
            name="cst_pis_cof_saida_aliq_zero"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_saida_aliq_zero}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_saida_aliq_zero', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_saida_aliq_zero: {
                  ...formRegraLoja.cst_pis_cof_saida_aliq_zero,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>

        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsEntrada}
            label="CST Entrada Monofásico"
            name="cst_pis_cof_ent_monof"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_ent_monof}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_ent_monof', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_ent_monof: {
                  ...formRegraLoja.cst_pis_cof_ent_monof,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsSaida}
            label="CST Saída Monofásico"
            name="cst_pis_cof_saida_monof"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_saida_monof}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_saida_monof', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_saida_monof: {
                  ...formRegraLoja.cst_pis_cof_saida_monof,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>

        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsEntrada}
            label="CST Entrada Substituição"
            name="cst_pis_cof_ent_subst"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_ent_subst}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_ent_subst', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_ent_subst: {
                  ...formRegraLoja.cst_pis_cof_ent_subst,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsSaida}
            label="CST Saída Substituição"
            name="cst_pis_cof_saida_subst"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_saida_subst}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_saida_subst', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_saida_subst: {
                  ...formRegraLoja.cst_pis_cof_saida_subst,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>

        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsEntrada}
            label="CST Entrada Imune"
            name="cst_pis_cof_ent_imune"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_ent_imune}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_ent_imune', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_ent_imune: {
                  ...formRegraLoja.cst_pis_cof_ent_imune,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsSaida}
            label="CST Saída Imune"
            name="cst_pis_cof_saida_imune"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_saida_imune}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_saida_imune', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_saida_imune: {
                  ...formRegraLoja.cst_pis_cof_saida_imune,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>

        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsEntrada}
            label="CST Entrada Suspensão"
            name="cst_pis_cof_ent_susp"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_ent_susp}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_ent_susp', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_ent_susp: {
                  ...formRegraLoja.cst_pis_cof_ent_susp,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-6">
          <InputSelect
            options={tipoPisCofinsSaida}
            label="CST Saída Suspensão"
            name="cst_pis_cof_saida_susp"
            control={control}
            register={register}
            isError={!!errors.cst_pis_cof_saida_susp}
            changeSelected={(selected: any) => {
              setValue('cst_pis_cof_saida_susp', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                cst_pis_cof_saida_susp: {
                  ...formRegraLoja.cst_pis_cof_saida_susp,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
            }}
          />
        </div>
      </div>
    </>
  );
};

export default PisCofins;
